import React from "react";
import "../styles/about.css";

function About() {
  return (
    <main className="about-page">
      <section className="page-header">
        <h1>About Us</h1>
        <p>Two decades of connecting markets across the globe.</p>
      </section>

      <section className="about-content">
        <div className="about-block">
          <h2>Our Story</h2>
          <p>
            KrivaExim started as a small trading desk and has grown
            into a full-service import-export partner working with clients
            across 40+ countries. We specialize in sourcing quality raw
            materials, machinery, and finished goods, and moving them
            reliably from origin to destination.
          </p>
        </div>
        <div className="about-block">
          <h2>Our Mission</h2>
          <p>
            To make global trade simple for businesses of any size &mdash;
            transparent pricing, dependable logistics, and a team that treats
            every shipment like it's the only one.
          </p>
        </div>
        <div className="about-block">
          <h2>Why Work With Us</h2>
          <ul>
            <li>25+ years of combined industry experience</li>
            <li>Verified suppliers and quality-checked sourcing</li>
            <li>End-to-end customs and freight handling</li>
            <li>Dedicated support from enquiry to delivery</li>
          </ul>
        </div>
      </section>
    </main>
  );
}

export default About;
